import { render, staticRenderFns } from "./ErrorDetailsModal.vue?vue&type=template&id=3133d45e&"
import script from "./ErrorDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ErrorDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports